import { Component, Directive, ElementRef, Injector, ChangeDetectionStrategy } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'main-template-directive',
    standalone: false,
})
export class MainTemplateDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('mainTemplate', elementRef, injector);
    }
}

@Component({
    selector: 'main-template',
    template: '<main-template-directive></main-template-directive>',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: []
})
export class MainTemplateComponent {};


@Directive({
    selector: 'two-columns-right-directive',
    standalone: false,
})
export class TwoColumnsRightDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('twoColumnsRightTemplate', elementRef, injector);
    }
}

@Component({
    selector: 'two-columns-right',
    template: '<two-columns-right-directive><router-outlet></router-outlet></two-columns-right-directive>',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: []
})
export class TwoColumnsRightComponent {
    constructor() {
        console.log("TwoColumnsRightComponent");
    }
}